class ConnectionService {
    constructor($rootScope, $q, $location, $log, $timeout, wtcpjsClientProviderService, persistenceService, profileModel, authService, mapLoaderService) {
        this.client = wtcpjsClientProviderService.getClient;

        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$log = $log;
        this.$timeout = $timeout;
        this.wtcpjsClientProviderService = wtcpjsClientProviderService;
        this.persistenceService = persistenceService;
        this.profileModel = profileModel;
        this.authService = authService;
        this.mapLoaderService = mapLoaderService;

        this.userLoggingIn = false;
        this.forcedDisconnect = false;
        this.accountDisabled = false;
        this.userLoggedInTooMany = false;
        this.tryAgain = false;
        this.isReconnecting = false;
        this.isReconnectCanceled = false;
        this.sessionTimedOut = false;
        this.userNoProfiles = false;
        this.unsubscribeChannelActivity = null;
        
        this.client().onConnectionClosed.subscribe( (err) => {
            $log.warn("ConnectionService.onConnectionClosed", err);
            this.disconnect();
            $rootScope.$emit("ConnectionService.connectionClosed", this.isReconnecting);
        });

        this.client().onSessionClosed.subscribe(data => {
            $log.warn("ConnectionService.onSessionClosed, data: ", data);
            if(!this.userLoggingIn) {
                switch (data.errorCode) {
                    case 0:
                        this.forcedDisconnect = true;
                        break;
                    case 7:
                        this.accountDisabled = true;
                        break;
                    case 19:
                        this.tryAgain = true;
                        break;
                    case 23:
                        this.userLoggedInTooMany = true;
                        break;
                    case 34:
                        this.sessionTimedOut = true;
                        break;
                    case 52:
                        this.userNoProfiles = true;
                        break;
                }
            }
        });
    }
 
    getCurrentUser() {
        return this.currentUser;
    }

    setCurrentUser(name, password, server, profileId) {
        //Proxy should return a server id that is unique for the system, not per proxy
        //If this is ever implemented, use that ID so we can store our user info once
        //no matter if there are multiple valid url's or if the user enters the ip address
        //for the Management Server instance. Using the server string has this draw back
        
        //Uncomment this when they add unique server id
        //this.persistenceService.updateUserInfo(name, profile, this.client().ServerId); 
        
        //Do this for now
        this.persistenceService.updateUserInfo(name, profileId, server);
        this.currentUser = { name, password, server };
        this.$log.debug('connectionService.currentUser: ', { name: this.currentUser.name, server: this.currentUser.name });
    }

    awaitSPCActivity(func) {
        if(this.unsubscribeChannelActivity) {
           this.unsubscribeChannelActivity();
        }

        var svc = this;
        this.unsubscribeChannelActivity = this.client().onChannelActivity.subscribe((data) => {
            svc.unsubscribeChannelActivity();
            svc.unsubscribeChannelActivity = null;

            var epId = data.endpoints[0].endpointInfo.endpointId;

            this.$rootScope.$broadcast('ConnectionService.login', {
                server: this.managementServerUrl,
                endpointId: epId
            });

            if(func) {
                func(epId);
            }
        });
    }

    reconnect(profileId) {

        profileId = profileId || this.profileModel.getSelectedProfile().profileId;

        let user = this.currentUser;
        let svc = this;
        this.$log.warn(`reconnecting to ${this.managementServerUrl}`);
        this.isReconnecting = true;

        this.$rootScope.$applyAsync(($scope) => {
            $scope.$broadcast('isReconnecting', true);

        return this.client()
            .connect(
                this.managementServerUrl,
                user.name,
                user.password,
                profileId)
            .then((data) => {
                svc.isReconnectCanceled = false;
                svc.$rootScope.$applyAsync(($scope) => {
                    svc.$log.warn('reconnected');
                    this.awaitSPCActivity((endpointId) => { svc.$rootScope.$broadcast('isReconnecting', svc.isReconnecting, endpointId);} );
                    svc.setProfileSuccess(true, profileId, data.channels, user.name, user.password, data.phoneLines, data.configInfo);
                    svc.isReconnecting = false;
                    svc.userLoggingIn = false;
                    svc.tryAgain = false;
                });
            })
            .catch((err) => {
                svc.$rootScope.$applyAsync(function($scope) {
                    svc.$log.warn('reconnect failed - ', err);
                    if (svc.isReconnecting) {
                        switch(err.errorCode) {
                            case 7:
                                svc.accountDisabled = true;
                                svc.isReconnecting = false;
                                svc.$rootScope.$broadcast('isReconnecting', svc.isReconnecting);
                                break;
                            case 8: // Removed from profile
                                svc.$location.path(svc.authService.loginPath);
                                svc.login(svc.currentUser.server, svc.currentUser.name, svc.currentUser.password)
                                    .then((profiles) => {
                                        svc.isReconnecting = false;
                                        svc.$rootScope.$broadcast('isReconnecting', svc.isReconnecting);

                                        if (profiles.length === 1) {
                                            svc.setProfile(svc.currentUser.name, svc.currentUser.password, profiles[0]);
                                            svc.$location.path('/main' + svc.authService.authUrlPath);
                                        } else {
                                            svc.isReconnectCanceled = true;
                                            svc.$rootScope.$broadcast('connectionService.selectNewProfile', profiles);
                                        }
                                    });
                                break;
                            case 52:
                                svc.isReconnecting = false;
                                svc.$rootScope.$broadcast('isReconnecting', svc.isReconnecting);

                                svc.userNoProfiles = true;
                                svc.disconnect();
                                break;
                            default:
                                svc.reconnectTimeout = svc.$timeout(() => svc.reconnect(), 2000);
                                break;
                        }
                    }
                });
            });
        });
    }

    cancelReconnect() {
        this.$log.warn("reconnect CANCELLED");
        this.isReconnecting = false;
        this.isReconnectCanceled = true;

        if (this.reconnectTimeout) {
            this.$timeout.cancel(this.reconnectTimeout);
        }

        this.logoutWithError('Problems connecting to server. Please check your connection');
    }

    disconnect() {
        this.$log.debug('disconnecting', this.currentUser.name, this.currentUser.server);
        this.client().AudioPlayerActive = false; //Silence the audio player immediately

        if (this.currentUser) {
            if (this.forcedDisconnect) { //Socket was closed from forced disconnect - do not reconnect
                this.forcedDisconnect = false; //Reset state
                this.logoutWithError('Your session has been forcibly terminated');
            } else if (this.accountDisabled) {
                this.accountDisabled = false; //Reset state
                this.logoutWithError('Your account has been disabled');
            } else if(this.userNoProfiles) {
                this.userNoProfiles = false; // Reset state
                this.logoutWithError("You must have at least one Profile to use WAVE. Please contact your administrator");
            } else if (!this.userLoggedInTooMany && !this.userLoggingIn && !this.isReconnectCanceled && !this.isReconnecting) {
                this.reconnect();
            }
        }
    }

    getAndResetLogoutError() {
        let error = this.logoutError;
        this.logoutError = undefined;
        return error;
    }

    logoutWithError(error) {
        this.logout();
        this.logoutError = error;
        this.$location.path(this.authService.loginPath);
    }

    createServerUrl(server, isOnSecurePage) {
        const wsRegex = /^ws{1,2}:\/\//;
        const httpsRegex = /^https?:\/\//;
        const endsInWaveRegex = /\/wave$/;

        const isRequestingInsecure = server.startsWith("http://") || server.startsWith("ws://");
        if (isOnSecurePage && isRequestingInsecure)
            throw new Error("MixedContent");

        let serverUrl = server;
        if (!(serverUrl.match(wsRegex) || serverUrl.match(httpsRegex))) {
            serverUrl = `https://${server}`;
        }

        return serverUrl;
    }

    login(managementServerUrl, username, password) {
        this.isReconnectCanceled = false;
        this.userLoggingIn = true;

        const defer = this.$q.defer();

        let serverUrl;
        try {
            const isSecure = window.location.protocol === "https:";
            serverUrl = this.createServerUrl(managementServerUrl, isSecure);
        } catch (ex) {
            defer.reject("You cannot open an insecure connection from a secure page");
        }

        this.$log.debug(`connecting to ${serverUrl}, (${username})`);

        this.managementServerUrl = serverUrl;

        this.client()
            .connect(serverUrl, username, password)
            .then(data => {
                this.$rootScope.$applyAsync((scope) => {
                    this.$log.debug("ConnectionService.login success, profiles:", data.profiles);
                    this.profileModel.setProfiles(data.profiles);
                    this.userLoggingIn = false;
                    defer.resolve(data.profiles);
                });
            })
            .catch(error => {
                this.$rootScope.$applyAsync((scope) => {
                    this.$log.error("Error calling client.connect: ", error);
                    defer.reject(this.getUserErrorMessage(error));
                });
            });

        return defer.promise;
    }
    setProfile(username, password, profile) {
        const defer = this.$q.defer();

        if (!this.managementServerUrl) {
            defer.reject("must call 'ConnectionService.login' beforehand to set the server address");
        }

        if(!password && this.currentUser) { // This is a reconnect scenario since the user has already logged in once
            username = this.currentUser.name;
            password = this.currentUser.password;
        }

        let setProfilePromise = null;

        if (this.sessionTimedOut) {
            setProfilePromise = this.client().connect(this.managementServerUrl, username, password, profile.profileId);
        }
        else {
            setProfilePromise = this.client().setProfile(username || "", password || "", profile.profileId);
        }

        this.awaitSPCActivity();

        setProfilePromise
            .then((data) => {
                this.$rootScope.$applyAsync((scope) => {
                    this.setProfileSuccess(false, profile.profileId, data.channels, username, password, data.phoneLines, data.configInfo);
                    this.mapLoaderService.setKeyFromProfileResponseAndCreateMapScriptNode(data);
                    this.$log.debug("connectionService.setProfile success", data);
                    this.isReconnectCanceled = false; // Reset any existing reconnect state information
                    defer.resolve();
                });
            })
            .catch(error => {
                this.$rootScope.$applyAsync((scope) => {
                    this.$log.error("Error calling client.setProfile: ", error);
                    defer.reject(this.getUserErrorMessage(error));
                });
            });

        return defer.promise;
    }

    setProfileSuccess(isReconnect, profileId, channels, userName, userPassword, phoneLines, configInfo) {

        this.profileModel.selectProfile(profileId, channels);
        this.setCurrentUser(userName, userPassword, this.managementServerUrl, profileId);
        this.$rootScope.$broadcast('ConnectionService.credentialsValidated', {
            reconnect: isReconnect,
            phoneLines: phoneLines,
            channels: channels
        });
        this.wtcpjsClientProviderService.setEndpointFilterThresholds(configInfo);
    }

    logout() {
        if (this.client().IsClientActive) {

            this.client().closeSession().then(() => {
                // Silence the audio player immediately (not required?)
                //this.client().AudioPlayerActive = false;
                this.$rootScope.$broadcast('ConnectionService.logout');
            });
        } else {
            this.$rootScope.$broadcast('ConnectionService.logout');
        }
    }

    getUserErrorMessage(err) {
        const errorCodes = {
            1: "There was an error",
            7: "User name or password were invalid.  Try again or contact your system administrator.",
            5: "The management server license is invalid. Please contact your administrator.",
            23: "You are already signed in from another client. Disconnect and try again",
            52: "You must have at least one Profile to use WAVE. Please contact your administrator"
        };

        if (err) {
            if (err.errorCode)
                return errorCodes[err.errorCode] || "There was an error";
            else
                return "Library Error: " + err;
        } else {
            return "There was an error";
        }
    }
}

angular
    .module('webcomm')
    .service('connectionService', [
        '$rootScope',
        '$q',
        '$location',
        '$log',
        '$timeout',
        'wtcpjsClientProviderService',
        'persistenceService',
        'profileModel',
        'authService',
        'mapLoaderService',
        ConnectionService]);
